define("shared/components/shared/ui/mobile-menu", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@ember/object", "@glimmer/component"], function (_exports, _component, _templateFactory, _service, _object, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"@ember/object",0,"@glimmer/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div data-test-id="mobile-app-header" class="cMN--container">
    <BasicDropdown as |emberDrop|>
      <emberDrop.Trigger @htmlTag="button" class="cMN--btn o--btn--outline o--btn--lg">
        {{svg-jar "menu" class="o--icon--lg"}}
      </emberDrop.Trigger>
      <emberDrop.Content data-test-id="social-profile-switcher-content">
        <div class="o--dropWrapper--md e--profileSwitcher--drop" ...attributes>
          <div class="o--dropBody">
  
            <ul class="o--dropBody__list o--dropBody--scroll o--page__switcherDrop">
              <li class="o--dropBody__item">
                <Shared::Ui::button
                  @type="unstyled"
                  class="cMN--nav__link o--dropBody__link u--ellipsis"
                  {{on "click" (fn this.transitionToMobile emberDrop.actions.close)}}
                >
                  {{svg-jar "home" class="o--icon--lg"}}
                  <span class="cMN--nav__label">{{t "mobile.home"}}</span>
                </Shared::Ui::button>
              </li>
              <li class="o--dropBody__item">
                <Shared::Ui::button
                  @type="unstyled"
                  class="cMN--nav__link o--dropBody__link u--ellipsis"
                  {{on "click" (fn this.transitionToLinkinbio emberDrop.actions.close)}}
                >
                  {{svg-jar "linkin-bio" class="o--icon--lg"}}
                  <span class="cMN--nav__label">{{t "shared_words.linkinbio"}}</span>
                </Shared::Ui::button>
              </li>
              <li class="o--dropBody__item">
                <Shared::Ui::button
                  @type="unstyled"
                  class="cMN--nav__link o--dropBody__link u--ellipsis"
                  {{on "click" (fn this.transitionToAccountOverview emberDrop.actions.close)}}
                >
                  {{svg-jar "settings" class="o--icon--lg"}}
                  <span class="cMN--nav__label">{{t "shared_words.settings"}}</span>
                </Shared::Ui::button>
              </li>
            </ul>
            {{#if this.onLinkinbioRoute}}
              <ul class="o--dropBody__list cMN--nav__accessGroup">
                {{#each this.groups as |group|}}
                  <Shared::Ui::GroupItem
                    @group={{group}}
                    @closeMenu={{emberDrop.actions.close}}
                    @isSelected={{are-equal this.currentGroup.id group.id}}
                  />
                {{/each}}
              </ul>
            {{/if}}
          </div>
        </div>
      </emberDrop.Content>
    </BasicDropdown>
  </div>
  
  */
  {
    "id": "lyJ/wbiC",
    "block": "[[[10,0],[14,\"data-test-id\",\"mobile-app-header\"],[14,0,\"cMN--container\"],[12],[1,\"\\n  \"],[8,[39,0],null,null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"Trigger\"]],[[24,0,\"cMN--btn o--btn--outline o--btn--lg\"]],[[\"@htmlTag\"],[\"button\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,1],[\"menu\"],[[\"class\"],[\"o--icon--lg\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"Content\"]],[[24,\"data-test-id\",\"social-profile-switcher-content\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[11,0],[24,0,\"o--dropWrapper--md e--profileSwitcher--drop\"],[17,2],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n\\n          \"],[10,\"ul\"],[14,0,\"o--dropBody__list o--dropBody--scroll o--page__switcherDrop\"],[12],[1,\"\\n            \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n              \"],[8,[39,2],[[24,0,\"cMN--nav__link o--dropBody__link u--ellipsis\"],[4,[38,3],[\"click\",[28,[37,4],[[30,0,[\"transitionToMobile\"]],[30,1,[\"actions\",\"close\"]]],null]],null]],[[\"@type\"],[\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,1],[\"home\"],[[\"class\"],[\"o--icon--lg\"]]]],[1,\"\\n                \"],[10,1],[14,0,\"cMN--nav__label\"],[12],[1,[28,[35,5],[\"mobile.home\"],null]],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n              \"],[8,[39,2],[[24,0,\"cMN--nav__link o--dropBody__link u--ellipsis\"],[4,[38,3],[\"click\",[28,[37,4],[[30,0,[\"transitionToLinkinbio\"]],[30,1,[\"actions\",\"close\"]]],null]],null]],[[\"@type\"],[\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,1],[\"linkin-bio\"],[[\"class\"],[\"o--icon--lg\"]]]],[1,\"\\n                \"],[10,1],[14,0,\"cMN--nav__label\"],[12],[1,[28,[35,5],[\"shared_words.linkinbio\"],null]],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n              \"],[8,[39,2],[[24,0,\"cMN--nav__link o--dropBody__link u--ellipsis\"],[4,[38,3],[\"click\",[28,[37,4],[[30,0,[\"transitionToAccountOverview\"]],[30,1,[\"actions\",\"close\"]]],null]],null]],[[\"@type\"],[\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,1],[\"settings\"],[[\"class\"],[\"o--icon--lg\"]]]],[1,\"\\n                \"],[10,1],[14,0,\"cMN--nav__label\"],[12],[1,[28,[35,5],[\"shared_words.settings\"],null]],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[30,0,[\"onLinkinbioRoute\"]],[[[1,\"            \"],[10,\"ul\"],[14,0,\"o--dropBody__list cMN--nav__accessGroup\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"groups\"]]],null]],null],null,[[[1,\"                \"],[8,[39,9],null,[[\"@group\",\"@closeMenu\",\"@isSelected\"],[[30,3],[30,1,[\"actions\",\"close\"]],[28,[37,10],[[30,0,[\"currentGroup\",\"id\"]],[30,3,[\"id\"]]],null]]],null],[1,\"\\n\"]],[3]],null],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"emberDrop\",\"&attrs\",\"group\"],false,[\"basic-dropdown\",\"svg-jar\",\"shared/ui/button\",\"on\",\"fn\",\"t\",\"if\",\"each\",\"-track-array\",\"shared/ui/group-item\",\"are-equal\"]]",
    "moduleName": "shared/components/shared/ui/mobile-menu.hbs",
    "isStrictMode": false
  });

  let MobileMenuComponent = (_class = class MobileMenuComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "router", _descriptor2, this);
    }

    get groups() {
      return this.auth.groups;
    }

    get currentGroup() {
      return this.auth.currentGroup;
    }

    get onLinkinbioRoute() {
      return this.router.currentRouteName.includes('linkinbio');
    }

    transitionToMobile(emberDropClose) {
      emberDropClose();
      this.router.transitionTo('cluster.mobile', this.auth.lastGroup.slug);
    }

    transitionToLinkinbio(emberDropClose) {
      emberDropClose();
      this.router.transitionTo('cluster.linkinbio', this.auth.lastGroup.slug);
    }

    transitionToAccountOverview(emberDropClose) {
      emberDropClose();
      this.router.transitionTo('account.overview');
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "transitionToMobile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToMobile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToLinkinbio", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToLinkinbio"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToAccountOverview", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToAccountOverview"), _class.prototype)), _class);
  _exports.default = MobileMenuComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MobileMenuComponent);
});